import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface AccountSetupState {
  expanded: boolean;
  isOpen: boolean;
  progress: number;
}

const initialState: AccountSetupState = {
  expanded: true,
  isOpen: true,
  progress: 0,
};

export const accountSetupSlice = createSlice({
  name: "accountSetup",
  initialState,
  reducers: {
    setExpanded: (state, action: PayloadAction<boolean>) => {
      state.expanded = action.payload;
    },
    setIsOpen: (state, action: PayloadAction<boolean>) => {
      state.isOpen = action.payload;
    },
    setProgress: (state, action: PayloadAction<number>) => {
      state.progress = action.payload;
    },
  },
});

export const { setExpanded, setIsOpen, setProgress } =
  accountSetupSlice.actions;

export default accountSetupSlice.reducer;
